<template>
    <div id="service-staff-setting" class="shadow-md rounded-item">
        <vx-card>
            <div class="setting-card-hidden">
                <div class="setting-card-scroll">
                    <h4 class="text-2xl font-bold mb-4">Store Rating On GCI App</h4>
                    <div class="flex align-center mb-base">
                        <vs-switch v-model="store_rating_display" class="my-6" @click.stop="updateStoreRating" />
                        <span class="pl-5">Display store rating on GCI app</span>
                    </div>
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>
export default {
    name: 'store-rating-on-gci-app',
    data() {
        return {
            store_rating_display: false,
            isOpenLoading: false,
            action_type: '',
            loaded_data_num: 0
        }
    },
    watch: {
        loaded_data_num: {
            immediate: true,
            handler() {
                if(this.loaded_data_num >= 1) {
                    this.closeLoading();
                } else {
                    this.action_type = "Get data";
                    this.openLoadingInDiv();
                }
            }
        }
    },
    methods: {
        openLoadingInDiv(){
            this.$vs.loading({
                container: '#app',
                scale: 0.8
            })
            if (this.loadTime) {
                clearTimeout(this.loadTime);
                this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout( ()=> {
                if(this.isOpenLoading) {
                    this.closeLoading();
                    this.$vs.dialog({
                        color: 'danger',
                        title: 'Notification',
                        text: this.action_type + ' failed',
                        acceptText: 'OK'
                    })
                }
            }, 10000);
        },
        closeLoading() {
            this.$vs.loading.close('#app > .con-vs-loading');
            this.isOpenLoading = false;
        },
        updateStoreRating() {
            let obj = {
                status: !this.store_rating_display ? 1 : 0
            }
            this.action_type = "Update";
            if(!this.isOpenLoading) {
                this.openLoadingInDiv();
            }
            this.$store.dispatch("appSetting/UPDATE_STORE_RATING_DISPLAY", obj).then(() => {
                this.closeLoading();
                this.$vs.notify({
                    title:'Notification',
                    text:'Update Store Rating Display Success',
                    color:'success',
                    position:'top-right'})
            }).catch((err) => {
                this.closeLoading();
                console.log('Error: ', err);
                this.$vs.notify({
                    title:'Notification',
                    text:'Update Store Rating Display Failed',
                    color:'danger',
                    position:'top-right'})
            })
        }
    },
    created() {
        this.$store.dispatch("appSetting/GET_STORE_RATING_DISPLAY").then((res) => {
            this.loaded_data_num++;
            let data = this.$store.getters["appSetting/storeRating"];
            this.store_rating_display = data && data.is_visible == 1 ? true : false;
        }).catch((err) => {
            console.log('Error: ', err);
        })
    }
}
</script>
